import { render } from "./insure-daily-operate-record.vue?vue&type=template&id=cbf20032&scoped=true&ts=true"
import script from "./insure-daily-operate-record.vue?vue&type=script&lang=ts"
export * from "./insure-daily-operate-record.vue?vue&type=script&lang=ts"

import "./insure-daily-operate-record.vue?vue&type=style&index=0&id=cbf20032&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbf20032"]])

export default __exports__